import sunaplAPI from '../../sunpalApi';
const ENTITY = 'proposals';

export const getMonitoringConfigs = (uuid) =>
    sunaplAPI.get(`/api/v1/${ENTITY}/monitoring/configs/${uuid}/`);

export const saveMonitoringConfigs = (id, data) =>
    sunaplAPI.put(`/api/v1/${ENTITY}/monitoring/configs/${id}/`, data);

export const createMonitoringConfigs = (data) =>
    sunaplAPI.post(`/api/v1/${ENTITY}/monitoring/configs/`, data);
